package com.parmartechnologies.core.feature.inventory.uom.model

import com.parmartechnologies.core.extension.BaseDataClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

/**
 * UOM (Unit of Measure) - A data model representing a unit of measurement in the inventory system.
 * 
 * Units of measure are essential for inventory management, allowing items to be tracked
 * in different quantities (e.g., pieces, boxes, pallets, kilograms, liters, etc.).
 * 
 * This class is serializable for database storage and API communication.
 */
@Serializable
data class UOM @OptIn(ExperimentalTime::class) constructor(

    // Numeric ID for the UOM, defaults to current epoch seconds
    @SerialName("uom_id") var UOMId: Long = Clock.System.now().epochSeconds,
    
    // ID of the user who created this unit of measure
    @SerialName("user_id") var UserID: String = "",
    
    // ID of the business this UOM belongs to
    @SerialName("business_id") var BusinessID: String = "",
    
    // ID of the store this UOM is associated with
    @SerialName("store_id") var storeId: String = "",
    
    // Soft delete flag (0 = active, 1 = deleted)
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    
    // Name of the unit of measure (e.g., "Box", "Kilogram", "Liter")
    @SerialName("name") var Name: String = "",
    
    // Numeric value representing the conversion factor or quantity
    @SerialName("value") var Value: Long = 0,
    
    // Detailed description of the unit of measure
    @SerialName("description") var Description: String = "",

): BaseDataClass()